import { createHash } from 'node:crypto';

/**
 * Non-reversible hash for anonymizing user IDs in analytics.
 * Uses SHA-256 and returns a deterministic string prefixed with "AUID_".
 *
 * @param str - The string to hash (e.g. userId). Must be non-falsy and longer than 2 characters.
 * @returns A deterministic anonymized identifier string.
 */
export function hashForAnalytics(str: string): string {
    if (!str || str.length <= 2) {
        return 'anonymous';
    }
    return 'AUID_' + createHash('sha256').update(str).digest('hex');
}
